/**
 * Deck Opening
 * Whether the deck is at its opening moment
 */

import { createContext, useContext } from 'react';

/**
 * True while the deck shows the slide it opened on — straight after the
 * password gate, before any navigation. The viewer brings that slide in
 * without its slide transition, so the slide may give itself an arrival
 * then; arriving from another slide, the transition is its entrance.
 */
export const DeckOpeningContext = createContext(false);

export function useDeckOpening(): boolean {
  return useContext(DeckOpeningContext);
}
